export default "__VITE_ASSET__CEFTVrB7__"